import { requestbody } from './request.js';

function unwrap(response) {
  if (!response || !response.data || response.data.code !== 1) {
    throw new Error(response && response.data && response.data.msg || '公司权限加载失败，请重试');
  }
  return response.data.data;
}

export const getCompanyPermissionMode = () => requestbody('/system/user-data-permission/mode', 'get', {}).then(unwrap);
export const getUserDataPermission = userId => requestbody('/system/user-data-permission', 'get', { userId }).then(unwrap);
export const saveUserDataPermission = data => requestbody('/system/user-data-permission', 'post', data).then(unwrap);
